import React from 'react';

function FieldError(props) {
    return (
        <p className='text-danger f-xsmal mb-0'>{props?.message}</p>
    );
}

export default FieldError;